function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "feedback",
  transform: "translate(0.25 0.25)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_37",
  "data-name": "Group 37",
  transform: "translate(4.868 3.895)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_36",
  "data-name": "Group 36"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M123.706,117.333h-2.434v.974h2.434a.487.487,0,0,1,.487.487v11.684a.487.487,0,0,1-.487.487H116.89a.487.487,0,0,0-.344.143l-1.116,1.116v-.772a.487.487,0,0,0-.487-.487h-6.816a.487.487,0,0,1-.487-.487v-1.46h-.974v1.46a1.461,1.461,0,0,0,1.46,1.46h6.329v1.46a.487.487,0,0,0,.831.344l1.8-1.8h6.614a1.46,1.46,0,0,0,1.46-1.46V118.794A1.46,1.46,0,0,0,123.706,117.333Z",
  transform: "translate(-106.667 -117.333)",
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_39",
  "data-name": "Group 39",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_38",
  "data-name": "Group 38"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_46",
  "data-name": "Path 46",
  d: "M17.039,32H1.46A1.46,1.46,0,0,0,0,33.46V45.144A1.46,1.46,0,0,0,1.46,46.6H8.276v1.46a.487.487,0,0,0,.831.344l1.8-1.8h6.127a1.46,1.46,0,0,0,1.46-1.46V33.46A1.461,1.461,0,0,0,17.039,32Zm.487,13.144a.487.487,0,0,1-.487.487H10.71a.487.487,0,0,0-.344.143L9.25,46.89v-.772a.487.487,0,0,0-.487-.487H1.46a.487.487,0,0,1-.487-.487V33.46a.487.487,0,0,1,.487-.487H17.039a.487.487,0,0,1,.487.487Z",
  transform: "translate(0 -32)",
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_41",
  "data-name": "Group 41",
  transform: "translate(2.434 3.895)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_40",
  "data-name": "Group 40"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_27",
  "data-name": "Rectangle 27",
  width: 5.355,
  height: 0.974,
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_43",
  "data-name": "Group 43",
  transform: "translate(2.434 6.816)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_42",
  "data-name": "Group 42"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_28",
  "data-name": "Rectangle 28",
  width: 13.631,
  height: 0.974,
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_45",
  "data-name": "Group 45",
  transform: "translate(2.434 9.737)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_44",
  "data-name": "Group 44"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_29",
  "data-name": "Rectangle 29",
  width: 13.631,
  height: 0.974,
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_47",
  "data-name": "Group 47",
  transform: "translate(15.092 3.895)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_46",
  "data-name": "Group 46"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_30",
  "data-name": "Rectangle 30",
  width: 0.974,
  height: 0.974,
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_49",
  "data-name": "Group 49",
  transform: "translate(13.144 3.895)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_48",
  "data-name": "Group 48"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_31",
  "data-name": "Rectangle 31",
  width: 0.974,
  height: 0.974,
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.5
}))));

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.868,
    height: 20.947,
    viewBox: "0 0 23.868 20.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.57eefe87.svg";
export { ForwardRef as ReactComponent };